import { AppRoutes } from "./Routes";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { useEffect, useState } from "react";
import { buildTheme } from "theme";
import { ThemeProvider } from "@emotion/react";
import { ThemeContext } from "theme/themeContext";

function App() {
  const fromStorage = localStorage.getItem("whiteTheme");
  const [whiteThemeState, setWhiteThemeStatePrivate] = useState(!!fromStorage);

  useEffect(() => {
    if (fromStorage) {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
    } else {
      document.body.classList.remove("light");
      document.body.classList.add("dark");
    }
  }, [!!fromStorage]);

  const setWhiteThemeState = (x: boolean) => {
    setWhiteThemeStatePrivate(x);
    if (x) {
      localStorage.setItem("whiteTheme", "1");
    } else {
      localStorage.removeItem("whiteTheme");
    }
  };

  const theme = buildTheme(!whiteThemeState ? "dark" : "light", () => {
    setWhiteThemeState(!whiteThemeState);
  });

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <ThemeContext.Provider
          value={{
            whiteMode: whiteThemeState,
            toggleTheme: () => {
              setWhiteThemeState(!whiteThemeState);
            },
          }}
        >
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ThemeContext.Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;
